module.exports = __webpack_public_path__ + "img/hero.d85195ed.png";